<template>
    <!-- 主页面样式组件 -->
    <div class="contents" :style="{ backgroundImage: 'url(' + bg + ')' }">
        <div class="container">
            <div class="text-center mb-9 pr-2 pl-2">
                <h5 class="text-center fw_900 c_233dd2">{{ title }}</h5>
                <h1 class="text-center fw_900 mt-4">{{ subtitle }}</h1>
                <div class="text-center mt-4">
                    <template v-if="Array.isArray(description)">
                        <p class="mb-1" v-for="value in description" :key="value">{{ value }}</p>
                    </template>
                    <template v-else>
                        <p class="mb-1">{{ description }}</p>
                    </template>
                </div>
                <div class="d-flex justify-content-center align-items-center flex-wrap main-page-actions">
                    <router-link
                        class="btn btn-outline-success"
                        :to="{ name: 'download' }"
                    >{{ buttonText }}</router-link>
                    <a
                        v-if="secondaryButtonHref"
                        :href="secondaryButtonHref"
                        class="btn btn-outline-success main-page-btn-secondary"
                        target="_blank"
                        rel="noopener noreferrer"
                    >{{ secondaryButtonText }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "mainPage",
    props: {
        title: {
            type: String,
            default: "标题"
        },
        subtitle: {
            type: String,
            default: "副标题"
        },
        description: {
            type: [String, Array],
            default: "",
        },
        buttonText: {
            type: String,
            default: "立即开通",
            description: "按钮文本"
        },
        secondaryButtonText: {
            type: String,
            default: "",
            description: "右侧次要按钮文案（空则不展示）"
        },
        secondaryButtonHref: {
            type: String,
            default: "",
            description: "右侧次要按钮链接（空则不展示）"
        },
        bg: {
            type: String,
            default: "/img/pay/0-_BG-5.png",
            description: "背景图片"
        },
    },
    data() {
        return {
        }
    },
    computed: {
    }
};
</script>
<style lang="scss" scoped>
.contents {
    height: var(--main-height);
    width: 100%;
    // background-image: url('/img/pay/0-_BG-5.png');
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;

    .container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}

.fw_900 {
    font-weight: 900;
}

.c_233dd2 {
    color: #233dd2;
}

.main-page-actions {
    margin-top: 3rem;
    gap: 0.75rem 1rem;
}

.main-page-btn-secondary {
    margin-left: 0;
}
</style>